import { Observable } from 'rxjs';

export const superagentToObservable = (request, abortOnUnsubscribe = true) =>
  new Observable(observer => {
    request.end((err, response) => {
      if (err) {
        observer.error(err);
      }
      if (response) {
        observer.next(response);
        observer.complete();
      }
    });

    return abortOnUnsubscribe ? () => request.abort() : null;
  });
